(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/router.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.Router = Backbone.Router.extend({
    routes: svs.core.data.routes,

    welcome: function() {
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        this.spela();
      } else {
        svs.maltipset.app.skeleton
          .getRegion('mainRegion')
          .show(new svs.maltipset.views.Welcome());
      }
    },

    spela: function(drawNumber, matchNum) {
      matchNum = matchNum || '1';
      svs.maltipset.collections.coupons.setCurrentCoupon(drawNumber);
      svs.maltipset.app.skeleton
        .getRegion('mainRegion')
        .show(new svs.maltipset.views.Play({ matchNum: matchNum }));
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        if (svs.core.detect.formfactor.mobile()) {
          var cmsDefaultTab = svs.maltipset.data.config.startPageConfig.defaultTab;
          if (!window.location.search && cmsDefaultTab) {
            this.navigate('?flik=' + cmsDefaultTab, { trigger: false, replace: true });
          }
        }
      } else {
        svs.core.deviceSession.get(
          'openXpertenFromWelcome',
          'Maltipset',
          function(data) {
            if (typeof data !== 'undefined' && data === true) {
              svs.core.deviceSession.remove(
                'openXpertenFromWelcome',
                'Maltipset'
              );
              svs.maltipset.controllers.maltipsetController.showXperten();
            }
          }
        );

        svs.core.deviceSession.get(
          'openSystemFromWelcome',
          'Maltipset',
          function(data) {
            if (typeof data !== 'undefined' && data === true) {
              svs.core.deviceSession.remove(
                'openSystemFromWelcome',
                'Maltipset'
              );
              svs.maltipset.controllers.maltipsetController.showSystemspel();
            }
          }
        );
      }
    }
  });
})(Backbone, _, svs);

 })(window);